import axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import {
  CreateMailServerDto,
  UpdateMailServerDto,
} from "../components/smtp-config/dto/smpt.dto";
import { notif } from "../components/utils/util";

const urls: { [key: string]: string } = {
  localhost: "http://localhost:3003",
  production: "https://npaa-api.mei.gov.rs",
  test: "https://npaa-api.we-deliver.net",
};

export const baseUrl = urls[process.env.REACT_APP_ENV || "localhost"];

let isHandlingSessionExpiry = false;

if (!(axios as any).__sessionExpiryInterceptorAttached) {
  (axios as any).__sessionExpiryInterceptorAttached = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        if (!isHandlingSessionExpiry && window.location.pathname !== "/login") {
          isHandlingSessionExpiry = true;
          localStorage.removeItem("accessToken");
          localStorage.removeItem("user");
          notif(
            error?.response?.data?.message ||
              "Сесија је истекла. Молимо вас да се поново пријавите.",
            "warning",
          );
          setTimeout(() => {
            window.location.href = "/login";
          }, 1500);
        }
        return new Promise(() => {});
      }
      return Promise.reject(error);
    },
  );
}

interface LoginDto {
  username: string;
  password: string;
}
function handleError(error: any) {
  return { status: error?.response?.status, data: error?.response?.data };
}
function handleSuccess(response: any) {
  const data = !!response.data ? response.data : response.data;
  const responseData = isJson(data) ? JSON.parse(data) : data;
  return { status: response.status, data: responseData };
}
const isJson = (str: any) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
export async function login(user: LoginDto) {
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/user/signin`,
    data: user,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertUser(user: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/user/insert`,
    data: user,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function addExpenditure(b: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/expenditure`,
    data: b,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNMeasureInfo(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasures/info?id=${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getExpenditure(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/expenditure?id=${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getCelexInfo(celex: any, offset: any = 0) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/jurisdiction/getcelexinfo?celex=${celex}&offset=${offset}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getExpenditureInfo(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/expenditure/info?id=${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getFoundSourceTypes() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/finsourcetypes`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function updateNatMeasJurastiction(nm: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/natmeas/jurastiction/update`,
    data: nm,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertMeasure(nm: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/measure/insert`,
    data: nm,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function editMeasure(nm: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/measure/edit`,
    data: nm,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function measureStatus(nm: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/measure/status`,
    data: nm,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function updateHelpPage(page: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/help/page/update`,
    data: page,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function insertPointer(page: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/pointer/insert`,
    data: page,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function editHarmonizationCompatibility(h: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/harmonizations/compatibility`,
    data: h,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertNoCelex(i: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/nocelexregister/insert`,
    data: i,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function editNoCelex(i: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/nocelexregister/edit`,
    data: i,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertHarmonization(h: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/harmonizations`,
    data: h,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertNationalMeasureInChargeInstitutions(h: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/inchargeinstitution`,
    data: h,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertNationalMeasureRelation(r: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/relation`,
    data: r,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function editUser(user: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/user/edit`,
    data: user,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertOJ(oj: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/oj/insert`,
    data: oj,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function editOJ(oj: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/oj/edit`,
    data: oj,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertNatGroupStructure(structure: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/group/structure`,
    data: structure,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function editUserPassword(user: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/user/edit/password`,
    data: user,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertOJNumber(ojNum: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/oj/number/insert`,
    data: ojNum,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function editOJNumber(ojNum: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/oj/number/edit`,
    data: ojNum,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertInstitution(institution: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/institutions/insert`,
    data: institution,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertNatMeasure(natMeasure: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/insert`,
    data: natMeasure,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function editNatMeasure(natMeasure: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/edit`,
    data: natMeasure,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function updateInstitution(institution: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/institutions/update`,
    data: institution,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function whoAmI() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/user/whoami`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNationalGroupSet(group: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/nationalgroupset?group=${group}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getExpenditures(
  limit: any,
  offset: any,
  role: any = "",
  term: any = "",
  sortModel: any = [],
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/expenditures?limit=${limit}&offset=${offset}&role=${role}&term=${term}&sortModel=${JSON.stringify(sortModel)}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNatGroupStructure(id: any, set: any) {
  console.log("🚀 ~ getNatGroupStructure ~ set:", set);
  console.log("🚀 ~ getNatGroupStructure ~ id:", id);
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/group/structure?id=${id}&set=${set}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNationalGroupSetByLevel(set: any, level: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/nationalgroupsetbylevel?setNo=${set}&level=${level}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getScreeningGroups(parent: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/groups/screening?parent=${parent}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getEuMeasureBy(
  limit: any,
  offset: any,
  celexNo: any,
  group: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/eumeasures/by?limit=${limit}&offset=${offset}&celexNo=${celexNo}&group=${group}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNatMeasureBy(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/by?id=${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getAdministrationUserInsert() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/user/insert`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getDefaultRole() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/settings/defaultRole`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getAllRoles() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/settings/roles`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getEuImportStatus() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/eu/import-status`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function startEuImport(set: number) {
  const token = localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: {},
    url: `${baseUrl}/administration/eu/insert?set=${set}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getEuStats() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/eu/stats`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getEuList(
  limit: any = 25,
  offset: any = 0,
  sort: string = "id",
  order: string = "ASC",
  searchParams?: Record<string, string>,
) {
  const token = await localStorage.getItem("accessToken");
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
    sort,
    order,
  });
  if (searchParams) {
    Object.entries(searchParams).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
  }
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/eu/list?${params.toString()}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getEuImportHistory(
  limit: number = 25,
  offset: number = 0,
  sort: string = "date",
  order: string = "DESC",
  searchParams?: Record<string, string>,
) {
  const token = await localStorage.getItem("accessToken");
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
    sort,
    order,
  });
  if (searchParams) {
    Object.entries(searchParams).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
  }
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/eu/import-history?${params.toString()}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getEuImportHistoryMeasures(
  importHistoryId: number,
  limit: number = 25,
  offset: number = 0,
  sort: string = "action",
  order: string = "ASC",
  searchParams?: Record<string, string>,
) {
  const token = await localStorage.getItem("accessToken");
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
    sort,
    order,
  });
  if (searchParams) {
    Object.entries(searchParams).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
  }
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/eu/import-history/${importHistoryId}/measures?${params.toString()}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getSDocs(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/strategydocs?id=${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertSDocs(payload: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/register/natmeasure/strategydocs`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNDocs(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/negotiationdocs?id=${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertNDocs(payload: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/register/natmeasure/negotiationdocs`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNDocsM(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/measure/negotiationdocs?id=${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertNDocsM(payload: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/measure/negotiationdocs`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function updateJur(payload: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/jurisdiction/update/`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function updateJurById(payload: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/jurisdiction/update/id`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function editJur(payload: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/jurisdiction/update/id`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function updateEuJur(payload: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/jurisdiction/eu/update`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function createJur(payload: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/jurisdiction/create`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function updateUserRole(id: string, roleId: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/settings/user/role/`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { id, roleId },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function updateSettings(id: string, value: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/settings/update/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { value },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getAllUsers(
  limit: any,
  offset: any,
  username: any,
  roleId: any,
  institutionId: any,
  name: any,
  orderByFieldName: string,
  orderByName: string,
  valid: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/users`,
    params: {
      limit,
      offset,
      username,
      roleId,
      institutionId,
      name,
      order: orderByFieldName ?? null,
      by: orderByName ?? null,
      valid,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getRegistersManagement(
  limit: any,
  offset: any,
  term: any,
  institutionId: any,
  role: any = "",
  type: any = "",
  user: any = "",
  orderByFieldName: string = "",
  orderByName: string = "",
  typeId: any = "",
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/natmeasures`,
    params: {
      limit,
      offset,
      term,
      institutionId,
      role,
      type,
      user,
      order: orderByFieldName ?? null,
      by: orderByName ?? null,
      natMeasureType: typeId,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getRegistersAdmin(
  limit: any,
  offset: any,
  term: any,
  institutionId: any,
  role: any = "",
  title: any = "",
  type: any = 0,
  user: any = "",
  orderByFieldName: string = "",
  orderByName: string = "",
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/natmeasures`,
    params: {
      limit,
      offset,
      term,
      institutionId,
      role,
      title,
      type,
      user,
      order: orderByFieldName,
      by: orderByName,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getMeasures(
  limit: any,
  offset: any,
  term: any,
  institutionId: any,
  filter: any,
  role: any = "",
  orderByFieldName: any = "",
  orderByName: any = "",
  from: any = "",
  to: any = "",
  group: any = "",
  subGroup: any = "",
  type: any = "",
) {
  const token = await localStorage.getItem("accessToken");
  const options = {
    method: "GET",
    url: `${baseUrl}/views/measures`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      limit,
      offset,
      institution: institutionId,
      term,
      filter,
      role,
      order: orderByFieldName,
      by: orderByName,
      from,
      to,
      group,
      subGroup,
      type,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getPirvIns(limit: any, offset: any, term: any) {
  const token = await localStorage.getItem("accessToken");
  const options = {
    method: "GET",
    url: `${baseUrl}/administration/pirvins`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      term,
      limit,
      offset,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getPirvMeasurs(
  limit: any,
  offset: any,
  id: any,
  term: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options = {
    method: "GET",
    url: `${baseUrl}/register/pirvmeasures`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      id,
      term,
      limit,
      offset,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getPirvMeasureById(id: any) {
  const token = await localStorage.getItem("accessToken");

  const options = {
    method: "GET",
    url: `${baseUrl}/register/pirvmeasures/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getPointers(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options = {
    method: "GET",
    url: `${baseUrl}/register/measure/pointers`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      id,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getInstRelationDelete(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options = {
    method: "GET",
    url: `${baseUrl}/administration/instdelrel?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getMeasureById(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options = {
    method: "GET",
    url: `${baseUrl}/register/measure/info?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getInstCelexViews(
  limit: any,
  offset: any,
  institutionId: any,
  filter: any,
  from: any,
  to: any,
  orderByFieldName: string = "",
  orderByName: string = "",
) {
  const token = await localStorage.getItem("accessToken");
  const options = {
    method: "GET",
    url: `${baseUrl}/views/institutioncelex`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      limit,
      offset,
      institution: institutionId,
      filter,
      from,
      to,
      order: orderByFieldName,
      by: orderByName,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function GetViewsQInstitution(
  limit: any,
  offset: any,
  institutionId: any,
  filter: any,
  from: any,
  to: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options = {
    method: "GET",
    url: `${baseUrl}/views/realisationinstitution`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      limit,
      offset,
      institution: institutionId,
      filter,
      from,
      to,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function GetViewsNPICelex(
  limit: any,
  offset: any,
  group: any,
  filter: any,
  from: any,
  to: any,
  orderByFieldName: string = "",
  orderByName: string = "",
) {
  const token = await localStorage.getItem("accessToken");
  const options = {
    method: "GET",
    url: `${baseUrl}/views/npicelex`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      limit,
      offset,
      group,
      filter,
      from,
      to,
      order: orderByFieldName,
      by: orderByName,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNatMeasuresSimpleRelation(
  limit: any,
  offset: any,
  term: any,
  searchId: any,
  type: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/natmeasures/simple/relation?limit=${limit}&offset=${offset}&term=${term}&type=${type}&searchId=${searchId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNatMeasuresSimple(
  limit: any,
  offset: any,
  term: any,
  searchId: any,
  type: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/natmeasures/simple?limit=${limit}&offset=${offset}&term=${term}&type=${type}&searchId=${searchId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getAllInstitutions(type: any = null) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/institutions/all`,
    params: { type },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getRegisterCompletion(id: any, set: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/natmeasure/completion`,
    params: { id, set },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getAllOfficialJournals() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/journals/all`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getOfficialJournals(offset: any, limit: any, term: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/journals?offset=${offset}&limit=${limit}&term=${term}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getAdministrationNoCelexRelations(
  offset: any,
  limit: any,
  term: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/nocelexregisters?offset=${offset}&limit=${limit}&term=${term}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getAdministrationNoCelexRelationById(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/nocelexregister?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function uploadTUFile(
  file: any,
  id: any,
  natMeasureId?: any,
  celex?: any,
) {
  const token = await localStorage.getItem("accessToken");
  const formData = new FormData();
  formData.append("file", file);
  formData.append("id", id);
  if (natMeasureId) {
    formData.append("natMeasureId", natMeasureId);
  }
  if (celex) {
    formData.append("celex", celex);
  }
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/administration/tufile/upload`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getTUFileById(id: any) {
  const token = await localStorage.getItem("accessToken");
  const response = await axios.get(`${baseUrl}/administration/tufile/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  });

  const contentDisposition = response.headers["content-disposition"];
  const name = contentDisposition?.split('="')[1].replace('"', "");
  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response?.status,
  };
}
export async function uploadEFile(file: any, id: any) {
  const token = await localStorage.getItem("accessToken");
  const formData = new FormData();
  formData.append("file", file);
  formData.append("id", id);
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/register/efile/upload`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getEFileById(id: any) {
  const token = await localStorage.getItem("accessToken");
  const response = await axios.get(`${baseUrl}/register/efile/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  });

  const contentDisposition = response.headers["content-disposition"];
  const name = contentDisposition?.split('="')[1].replace('"', "");
  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response?.status,
  };
}
export async function getInstitutionCelexFile(
  i: any,
  from: any,
  to: any,
  filter: any,
  reporting?: any,
  search?: string,
) {
  const token = localStorage.getItem("accessToken");
  const safeSearch =
    typeof search === "string" && search.length > 0 ? search : '""';

  const response = await axios.get(`${baseUrl}/views/doc/institution-celex`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
    params: {
      institution: i,
      from,
      to,
      filter,
      reporting,
      search: safeSearch,
    },
  });

  const contentDisposition = response.headers["content-disposition"];
  let name = "document.docx";

  if (contentDisposition) {
    const utf8Match = contentDisposition.match(
      /filename\*=UTF-8''(.+?)(?:;|$)/,
    );
    if (utf8Match) {
      name = decodeURIComponent(utf8Match[1]);
    } else {
      const match = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/);
      if (match) {
        name = match[1];
      }
    }
  }
  if (response.data) {
    response.data.name = name;
  }

  return response;
}

export async function getEDoc(id: any) {
  const token = await localStorage.getItem("accessToken");
  const response = await axios.get(
    `${baseUrl}/views/doc/expenditure?id=${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    },
  );

  const contentDisposition = response.headers["content-disposition"];
  const name = contentDisposition?.split('="')[1].replace('"', "");

  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response?.status,
  };
}
export async function getFinDoc() {
  const token = await localStorage.getItem("accessToken");
  const response = await axios.get(`${baseUrl}/views/doc/fin`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  });

  const contentDisposition = response.headers["content-disposition"];
  const name = contentDisposition?.split('="')[1].replace('"', "");

  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response?.status,
  };
}
export async function getMeasureDoc(
  term: any,
  institution: any,
  translation: any,
  from: any,
  to: any,
  group: any,
  subGroup: any,
) {
  const token = await localStorage.getItem("accessToken");
  const response = await axios.get(`${baseUrl}/views/doc/measure`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      term,
      institution,
      filter: translation,
      from,
      to,
      group,
      subGroup,
    },
    responseType: "blob",
  });

  const contentDisposition = response.headers["content-disposition"];
  const name = contentDisposition?.split('="')[1].replace('"', "");

  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response?.status,
  };
}
export async function getQFile(institutionId: any, from: any, to: any) {
  const token = await localStorage.getItem("accessToken");
  const response = await axios.get(`${baseUrl}/views/doc/quartile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      institution: institutionId,
      from,
      to,
    },
    responseType: "blob",
  });

  const contentDisposition = response.headers["content-disposition"];
  const name =
    contentDisposition?.split('="')[1]?.replace('"', "") ?? "report.docx";

  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response?.status,
  };
}

export async function getJurFile(params: {
  no: string | number;
  institution?: string | number;
  filter?: string | number;
  celex?: string;
}) {
  const token = localStorage.getItem("accessToken");

  const response = await axios.get(`${baseUrl}/views/doc/jurisdiction`, {
    params: {
      no: params.no,
      institution: params.institution || undefined,
      filter: params.filter || undefined,
      celex: params.celex || undefined,
    },
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });

  const cd = response.headers["content-disposition"] ?? "";
  const utf = cd.match(/filename\*=UTF-8''([^;]+)/i);
  const plain = cd.match(/filename="?([^"]+)"?/i);
  const name = utf
    ? decodeURIComponent(utf[1])
    : (plain?.[1] ?? "document.docx");

  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response.status,
  };
}

export async function getClusterFile(
  g: any,
  from: any,
  to: any,
  filter: any,
  reporting?: boolean,
  search?: string,
) {
  const safeSearch =
    typeof search === "string" && search.length > 0 ? search : '""';
  const token = await localStorage.getItem("accessToken");
  const response = await axios.get(
    `${baseUrl}/views/doc/cluster?group=${g}&from=${from}&to=${to}&filter=${filter}&reporting=${reporting}&search=${safeSearch}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    },
  );

  const contentDisposition = response.headers["content-disposition"];
  let name = "document.docx";

  if (contentDisposition) {
    const utf8Match = contentDisposition.match(
      /filename\*=UTF-8''(.+?)(?:;|$)/,
    );
    if (utf8Match) {
      name = decodeURIComponent(utf8Match[1]);
    } else {
      const match = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/);
      if (match) {
        name = match[1];
      }
    }
  }

  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response?.status,
  };
}
export async function getNPIFile(g: any, from: any, to: any, filter: any) {
  const token = await localStorage.getItem("accessToken");
  const response = await axios.get(
    `${baseUrl}/views/doc/npi?group=${g ?? ""}&from=${from}&to=${to}&filter=${filter}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    },
  );

  const contentDisposition = response.headers["content-disposition"];
  let name = "document.docx";

  if (contentDisposition) {
    if (contentDisposition.includes("filename*=UTF-8''")) {
      const parts = contentDisposition.split("filename*=UTF-8''");
      name = decodeURIComponent(parts[1]);
    } else if (contentDisposition.includes("filename=")) {
      name = contentDisposition.split("filename=")[1].replace(/['"]/g, "");
    }
  }

  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response?.status,
  };
}
export async function deleteTUFile(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/administration/tufile/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteNatMeasure(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/register/natmeasure/delete`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { id },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getOJNumbers(
  offset: any,
  limit: any,
  year: any,
  jId: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/oj/numbers?offset=${offset}&limit=${limit}&year=${year}&jid=${jId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getViewsNPI(includeClusters = true) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/views/npi-list?includeClusters=${includeClusters}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getEFiles(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/efiles?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getExpi(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/expi?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getViewsClusterTree() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/views/cluster-tree`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getViewsCluster() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/views/cluster-list`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getAllParameters() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/parameters`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getAllParameterByName(n: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/parameter/${n}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function updateParameters(id: string, updatedData: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/administration/parameter/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: updatedData,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getUsersByInstitution(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/users/by/institution?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getScreeningTree(term: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/jurisdiction/screenings?term=${term}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getJurisdictions(
  offset: any,
  limit: any,
  institution: any,
  group: any,
  filter: any,
  celex: any,
  orderByFieldName: string = "",
  orderByName: string = "",
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/jurisdiction/get`,
    params: {
      limit,
      offset,
      institution,
      group,
      filter,
      celex,
      order: orderByFieldName,
      by: orderByName,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getTUList(
  offset: any,
  limit: any,
  celex: any,
  natMeasure: any,
  file: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/tu/list?offset=${offset}&limit=${limit}&celex=${celex}&file=${file}&natMeasure=${natMeasure}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getInstitutions(
  offset: any,
  limit: any,
  term: any,
  type: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/institutions?offset=${offset}&limit=${limit}&term=${term}&type=${type}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getUserById(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",

    url: `${baseUrl}/administration/userby/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function loadOJDateById(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",

    url: `${baseUrl}/administration/oj/date/by/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getOJbyId(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",

    url: `${baseUrl}/administration/oj/by/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function loadInstitutionById(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/administration/institution/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getHelpPageByName(name: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/help/page/${name}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getSettingsTypeof(type: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/settings/typeof/${type}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getSettingByName(name: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/settings/name/${name}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getAllRolesWithFeatures() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/settings/roles/feature`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getHelpList() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/help/list`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getNoCelexRelations() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/natmeasure/norelationcelex`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getHarmonizations(offset: any, limit: any, id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/natmeasure/harmonizations?id=${id}&limit=${limit}&offset=${offset}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNationalMeasureInChargeInstitutions(
  offset: any,
  limit: any,
  id: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/natmeasure/inchargeinstitutions?id=${id}&limit=${limit}&offset=${offset}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getAllFeatures() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/settings/features/all`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteExpenditure(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/register/expenditure?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteRole(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/settings/user/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteMeasure(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/register/measure?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteOJNumber(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/administration/oj/number/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteNoCelex(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/administration/nocelexregister/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteInstitution(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/administration/institutions/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteOJ(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/administration/oj/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteNationalMeasureRelation(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/register/natmeasure/relation?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteNationalMeasureInChargeInstitutions(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/register/natmeasure/inchargeinstitution?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteHarmonization(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/register/natmeasure/harmonizations?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function createExpi(h: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/expi`,
    data: h,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertMeasureInChargeInstitutions(h: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/measure/inchargeinstitution`,
    data: h,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getMeasureInChargeInstitutions(
  offset: any,
  limit: any,
  id: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/measure/inchargeinstitutions?id=${id}&limit=${limit}&offset=${offset}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteMeasureInChargeInstitutions(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/register/measure/inchargeinstitution?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNationalMeasureRelationTypes() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/natmeasure/relation/types`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getNationalMeasureRelations(
  offset: any,
  limit: any,
  id: any,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/natmeasure/relations?offset=${offset}&limit=${limit}&id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function getExpenditureTypes() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/register/expenditure/types`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteNatMeasureStructure(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/register/natmeasure/group/structure?id=${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function deleteUser(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    url: `${baseUrl}/administration/user/${id}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function measureAddNationalMeasure(
  measureId: number,
  nationalMeasureId: number,
): Promise<any> {
  const token = await localStorage.getItem("accessToken");
  const headers = { Authorization: `Bearer ${token}` };
  const options = {
    method: "POST",
    url: `${baseUrl}/measure/addNationalMeasure`,
    headers,
    data: { measureId, nationalMeasureId },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function measureRemoveNationalMeasure(id: any): Promise<any> {
  const token = await localStorage.getItem("accessToken");
  const headers = { Authorization: `Bearer ${token}` };
  const options = {
    method: "DELETE",
    url: `${baseUrl}/measure/removeNationalMeasure`,
    headers,
    data: { id },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function measureListNationalMeasures(
  measureId: number,
): Promise<any> {
  const token = await localStorage.getItem("accessToken");
  const headers = { Authorization: `Bearer ${token}` };
  const options = {
    method: "GET",
    url: `${baseUrl}/measure/listNationalMeasures/${measureId}`,
    headers,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function measureAddEuMeasure(
  celexNo: string,
  measureId: number,
): Promise<any> {
  const token = await localStorage.getItem("accessToken");
  const headers = { Authorization: `Bearer ${token}` };
  const options = {
    method: "POST",
    url: `${baseUrl}/measure/addEuMeasure`,
    headers,
    data: { measureId, celexNo },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}
export async function removePointer(id: any): Promise<any> {
  const token = await localStorage.getItem("accessToken");
  const headers = { Authorization: `Bearer ${token}` };
  const options = {
    method: "DELETE",
    url: `${baseUrl}/measure/pointer`,
    headers,
    data: { id },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}
export async function removeJurResp(id: any): Promise<any> {
  const token = await localStorage.getItem("accessToken");
  const headers = { Authorization: `Bearer ${token}` };
  const options = {
    method: "DELETE",
    url: `${baseUrl}/jurisdiction/${id}`,
    headers,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}
export async function measureRemoveEuMeasure(id: any): Promise<any> {
  const token = await localStorage.getItem("accessToken");
  const headers = { Authorization: `Bearer ${token}` };
  const options = {
    method: "DELETE",
    url: `${baseUrl}/measure/removeEuMeasure`,
    headers,
    data: { id },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function measureListEuMeasures(measureId: number): Promise<any> {
  const token = await localStorage.getItem("accessToken");
  const headers = { Authorization: `Bearer ${token}` };
  const options = {
    method: "GET",
    url: `${baseUrl}/measure/listEuMeasures/${measureId}`,
    headers,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}
export async function getResp2Jur(celex: string): Promise<any> {
  const token = await localStorage.getItem("accessToken");
  const headers = { Authorization: `Bearer ${token}` };
  const options = {
    method: "GET",
    url: `${baseUrl}/jurisdiction/resp2?celex=${celex}`,
    headers,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}
export async function getPrintData(id: any) {
  const token = await localStorage.getItem("accessToken");
  const headers = { Authorization: `Bearer ${token}` };
  const options = {
    method: "GET",
    url: `${baseUrl}/register/natmeasure/forprint/by?id=${id}`,
    headers,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function lockEditing(data: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/lock-editing`,
    data,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function lockEditingHistory(limit?: number, offset?: number) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/lock-editing-history`,
    params: {
      limit,
      offset,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function lockEditingStatus() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/administration/lock-editing-current`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getNationalMeasuresCount(roleView: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/views/national-measure-count-for-reporting?roleView=${roleView}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function getMeasuresCount(roleView: string) {
  const token = await localStorage.getItem("accessToken");

  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/views/measures-count-for-reporting?roleView=${roleView}`,
  };

  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function getNationalMeasuresForReporting(
  limit: any,
  offset: any,
  searchString: any,
  institutionId: any,
  status: any,
  sortField: any,
  sortOrder: any,
) {
  const token = await localStorage.getItem("accessToken");

  const payload = {
    limit: Number(limit),
    offset: Number(offset),
    searchString: searchString ?? "",
    institutionId: institutionId ?? null,
    status: typeof status === "string" ? status : (status ?? ""),
    sortField: sortField ?? "",
    sortOrder: sortOrder ?? "",
  };

  const options: any = {
    method: "POST",
    url: `${baseUrl}/views/national-measures-for-reporting`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: payload,
  };

  return axios(options)
    .then((response: any) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function getMeasuresForReporting(
  limit: any,
  offset: any,
  searchString: any,
  institutionId: any,
  status: any,
  sortField: any,
  sortOrder: any,
  statusSortMode: any,
  deadlineSortMode: any,
) {
  const token = await localStorage.getItem("accessToken");

  const payload = {
    limit: Number(limit),
    offset: Number(offset),
    searchString: searchString ?? "",
    institutionId: institutionId ?? null,
    status: typeof status === "string" ? status : (status ?? ""),
    sortField: sortField ?? "",
    sortOrder: sortOrder ?? "",
    statusSortMode: statusSortMode ?? 0,
    deadlineSortMode: deadlineSortMode ?? 0,
  };

  const options: any = {
    method: "POST",
    url: `${baseUrl}/views/measures-for-reporting`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: payload,
  };

  return axios(options)
    .then((response: any) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function updateRealisationDate({
  id,
  adopByGovDate,
  reportId,
}: {
  id: number;
  adopByGovDate: Date | null;
  reportId?: number;
}) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/realisationdate`,
    data: {
      id,
      adopByGovDate,
      reportId,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function changePirv(id: number, pirvId: number) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/change-pirv-measure`,
    data: {
      id,
      pirvId,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function updateRealisationNote({
  id,
  note,
  reportId,
}: {
  id: number;
  note: string | null;
  reportId?: number;
}) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/realisation-note`,
    data: {
      id,
      note,
      reportId,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function updateNatMeasureOJ(data: {
  id: number;
  dateOfOJ?: Date;
  inForceOJ?: Date;
  inUseOJ?: Date;
  ojId?: number;
  OJNumber?: string;
  OJPagesNumber?: string;
  reportId?: number;
}) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/update-oj`,
    data,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function updateMeasureNote({ id, note, reportId }: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/measure/measure-note`,
    data: {
      id,
      note,
      reportId,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function updateMeasureStatus({
  id,
  status,
  comment,
  reportId,
}: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/measure/measure-status`,
    data: {
      id,
      status,
      comment,
      reportId,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function updateRealisationStatusNote({
  id,
  nationalMeasureId,
  name,
  reportId,
  quarter,
  status,
}: {
  id?: number;
  nationalMeasureId: number;
  name: string;
  reportId?: number;
  quarter?: string;
  status?: boolean;
}) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/natmeasure/realisation-status-note`,
    data: { id, nationalMeasureId, name, reportId, quarter, status },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function getAvailableNewQuarters(type: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/views/new-reporting-quarters?type=${type}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function getCurrentQuarters(
  type: string,
  offset: number,
  limit: number,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/views/available-reporting-quarters?type=${type}&skip=${offset}&take=${limit}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function createNewRegulationReportingQuarter(quarter: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/views/init-reporting`,
    data: {
      quarter,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function createNewMeasureReportingQuarter(quarter: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/views/init-measure-reporting`,
    data: {
      quarter,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function changeLockStatus(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/views/update-reporting-quarter-status?id=${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function getRegulationReportCounts(id: string, roleView: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/views/regulation-report-counts?id=${id}&roleView=${roleView}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function getMeasuresReportCounts(id: string, roleView: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/views/measure-report-counts?id=${id}&roleView=${roleView}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function getReportingMeasuresByQuarter(
  id: string,
  limit: any,
  offset: any,
  searchString: any,
  institutionId: any,
  status: any,
  sortField: any,
  sortOrder: any,
  statusSortMode: any,
  deadlineSortMode: any,
) {
  const token = await localStorage.getItem("accessToken");

  const payload = {
    id,
    limit: Number(limit),
    offset: Number(offset),
    searchString: searchString ?? "",
    institutionId: institutionId ?? null,
    status: typeof status === "string" ? status : (status ?? ""),
    sortField: sortField ?? "",
    sortOrder: sortOrder ?? "",
    statusSortMode: statusSortMode ?? null,
    deadlineSortMode: deadlineSortMode ?? null,
  };

  const options: any = {
    method: "POST",
    url: `${baseUrl}/views/reporting-measure-quarter`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: payload,
  };

  return axios(options)
    .then((response: any) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function getNationalMeasureReportingByQuarter(
  id: string,
  limit: any,
  offset: any,
  searchString: any,
  institutionId: any,
  status: any,
  sortField: any,
  sortOrder: any,
) {
  const token = await localStorage.getItem("accessToken");

  const payload = {
    id,
    limit: Number(limit),
    offset: Number(offset),
    searchString: searchString ?? "",
    institutionId: institutionId ?? null,
    status: typeof status === "string" ? status : (status ?? ""),
    sortField: sortField ?? "",
    sortOrder: sortOrder ?? "",
  };

  const options: any = {
    method: "POST",
    url: `${baseUrl}/views/reporting-quarter`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: payload,
  };

  return axios(options)
    .then((response: any) => handleSuccess(response))
    .catch((error: any) => handleError(error));
}

export async function getMeasureReportDoc(
  reportId: string,
  institutionId?: number,
  searchString?: string,
  status?: string,
) {
  const token = await localStorage.getItem("accessToken");

  const safeSearch =
    typeof searchString === "string" && searchString.trim().length > 0
      ? searchString.trim()
      : '""';

  const safeInstitution =
    typeof institutionId === "number" ? String(institutionId) : "null";

  const safeStatus =
    typeof status === "string" && status.trim().length > 0 ? status.trim() : "";

  const url =
    `${baseUrl}/views/measure-reporting-file/` +
    `${encodeURIComponent(reportId)}` +
    `&institutionId=${encodeURIComponent(safeInstitution)}` +
    `&searchString=${encodeURIComponent(safeSearch)}` +
    `?status=${encodeURIComponent(safeStatus)}`;

  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  });

  const contentDisposition = response.headers["content-disposition"] || "";

  const filenameFromHeader = (() => {
    const filenameStarMatch = contentDisposition.match(
      /filename\*=UTF-8''([^;\n\r]+)/i,
    );
    if (filenameStarMatch && filenameStarMatch[1]) {
      try {
        return decodeURIComponent(filenameStarMatch[1]);
      } catch (e) {
        return filenameStarMatch[1];
      }
    }

    const filenameMatch = contentDisposition.match(
      /filename=(?:"?)([^";\n\r]+)(?:"?)/i,
    );
    if (filenameMatch && filenameMatch[1]) return filenameMatch[1];

    return "";
  })();

  return {
    data: {
      data: response.data,
      name: filenameFromHeader,
      type: response.headers["content-type"],
    },
    status: response?.status,
  };
}

export async function getMeasureReportingByInstitution(
  id: string,
  institutionId?: number,
  searchString?: string,
) {
  return getMeasureReporting(
    "/views/measure-reporting-by-institution",
    id,
    institutionId,
    searchString,
  );
}

export async function getMeasureReportingByInstitutionCluster(
  id: string,
  institutionId?: number,
  searchString?: string,
  status?: string,
) {
  return getMeasureReporting(
    "/views/measure-reporting-by-institution-cluster",
    id,
    institutionId,
    searchString,
    status,
  );
}

export async function getMeasureReporting(
  endpoint: string,
  id: string,
  institutionId?: number,
  searchString?: string,
  status?: string,
) {
  const safeSearch =
    typeof searchString === "string" && searchString.length > 0
      ? searchString
      : '""';
  const token = await localStorage.getItem("accessToken");
  const response = await axios.get(
    `${baseUrl}${endpoint}/${id}&institutionId=${institutionId}&searchString=${safeSearch}&status=${status}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    },
  );

  const contentDisposition = response.headers["content-disposition"] || "";

  const filenameFromHeader = (() => {
    const filenameStarMatch = contentDisposition.match(
      /filename\*=UTF-8''([^;\n\r]+)/i,
    );
    if (filenameStarMatch && filenameStarMatch[1]) {
      try {
        return decodeURIComponent(filenameStarMatch[1]);
      } catch (e) {
        return filenameStarMatch[1];
      }
    }

    const filenameMatch = contentDisposition.match(
      /filename=(?:"?)([^";\n\r]+)(?:"?)/i,
    );
    if (filenameMatch && filenameMatch[1]) return filenameMatch[1];

    return "";
  })();

  return {
    data: {
      data: response.data,
      name: filenameFromHeader,
      type: response.headers["content-type"],
    },
    status: response?.status,
  };
}

export async function getMeasureSDocs(id: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/measure/strategydocs?id=${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
export async function insertMeasureSDocs(payload: any) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/measure/strategydocs`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: payload,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getInstitutionCelexFileNew(
  i: any,
  from: any,
  to: any,
  filter: any,
  reporting?: any,
  search?: string,
  reportingId?: string,
  status?: any,
) {
  const token = await localStorage.getItem("accessToken");
  const safeSearch =
    typeof search === "string" && search.length > 0 ? search : '""';
  const response = await axios.get(
    `${baseUrl}/views/doc/new-institution-celex?institution=${i}&from=${from}&to=${to}&filter=${filter}&reporting=${reporting}&search=${safeSearch}&${reportingId ? `reportingId=${reportingId}` : ""}&${status ? `status=${status}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    },
  );

  const contentDisposition = response.headers["content-disposition"];
  let name = "document.docx";

  if (contentDisposition) {
    const utf8Match = contentDisposition.match(
      /filename\*=UTF-8''(.+?)(?:;|$)/,
    );
    if (utf8Match) {
      name = decodeURIComponent(utf8Match[1]);
    } else {
      const match = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/);
      if (match) {
        name = match[1];
      }
    }
  }

  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response?.status,
  };
}

export async function getClusterFileNew(
  g: any,
  from: any,
  to: any,
  filter: any,
  reporting?: boolean,
  search?: string,
  reportingId?: string,
  status?: any,
) {
  const safeSearch =
    typeof search === "string" && search.length > 0 ? search : '""';
  const token = await localStorage.getItem("accessToken");
  const response = await axios.get(
    `${baseUrl}/views/doc/cluster-new?group=${g}&from=${from}&to=${to}&filter=${filter}&reporting=${reporting}&search=${safeSearch}&${reportingId ? `reportingId=${reportingId}` : ""}&${status ? `status=${status}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    },
  );

  const contentDisposition = response.headers["content-disposition"];
  let name = "document.docx";

  if (contentDisposition) {
    const utf8Match = contentDisposition.match(
      /filename\*=UTF-8''(.+?)(?:;|$)/,
    );
    if (utf8Match) {
      name = decodeURIComponent(utf8Match[1]);
    } else {
      const match = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/);
      if (match) {
        name = match[1];
      }
    }
  }

  return {
    data: { data: response.data, name, type: response.headers["content-type"] },
    status: response?.status,
  };
}

export async function getAllMailServers() {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/mail/servers`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function checkMailServerExists() {
  const options: AxiosRequestConfig = {
    method: "GET",
    url: `${baseUrl}/mail/servers/exists`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function sendPasswordResetEmail(email: string) {
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/user/resend/password`,
    data: { email },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function createMailServer(mailServerData: CreateMailServerDto) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/mail/servers`,
    data: mailServerData,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function updateMailServer(
  id: string,
  mailServerData: UpdateMailServerDto,
) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/mail/servers/${id}`,
    data: mailServerData,
  };
  return axios(options).then((response) => handleSuccess(response));
}

export async function deleteMailServer(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/mail/servers/${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function resetPassword({
  email,
  token,
  password,
}: {
  email: string;
  token: string;
  password: string;
}) {
  const options: AxiosRequestConfig = {
    method: "POST",
    url: `${baseUrl}/user/reset/password`,
    data: { email, token, password },
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getMeasureLogs(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/register/measure-logs/${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

// ─── Email Log API ──────────────────────────────────────────────────────────────
export async function getEmailLogs(params: {
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
  purpose?: string;
  dateFrom?: string;
  dateTo?: string;
}) {
  const token = await localStorage.getItem("accessToken");
  const query = new URLSearchParams();
  if (params.page) query.append("page", String(params.page));
  if (params.limit) query.append("limit", String(params.limit));
  if (params.status) query.append("status", params.status);
  if (params.search) query.append("search", params.search);
  if (params.purpose) query.append("purpose", params.purpose);
  if (params.dateFrom) query.append("dateFrom", params.dateFrom);
  if (params.dateTo) query.append("dateTo", params.dateTo);
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/mail/logs?${query.toString()}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function getEmailLogById(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/mail/logs/${id}`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}

export async function resendEmail(id: string) {
  const token = await localStorage.getItem("accessToken");
  const options: AxiosRequestConfig = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${baseUrl}/mail/logs/${id}/resend`,
  };
  return axios(options)
    .then((response) => handleSuccess(response))
    .catch((error) => handleError(error));
}
